<template>
  <div @click="openComplex" class="complex">
    <div class="complex__item complex__item--system">{{ complex.human_system_type.title }}</div>
    <div class="complex__item complex__item--complex-name">{{ complex.name }}</div>
    <div class="complex__item complex__item--date item">
      <i class="el-icon-date"></i>
      <span class="item__content">
        {{ this.$root.dateIso(complex.created_at) }}
      </span>
    </div>
    <div class="complex__item complex__item--specialist-name item">
      <i class="el-icon-user"></i>
      <span class="item__content">
        {{ complex.specialist }}
      </span>
    </div>
    <div @click.stop="deleteComplex" class="complex__button">
      <i class="el-icon-delete"></i>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex"

export default {
 name: "ComplexListItem",
 props: {
   complex: {
     type: Object,
     required: true,
     default: () => ({})
   },
   index: {
     type: Number,
     required: true
   }
 },
  methods: {
   ...mapActions({
     startLoadingList: "complexExercises/startLoadingList"
   }),
   openComplex() {
     this.$router.push({name: "complexExercises.item", params: {id: this.complex.id}})
   },
   deleteComplex() {
     this.$emit('delete', this.complex.id)
     this.startLoadingList()
   },
  }
}
</script>

<style scoped lang="scss">
.complex {
  position: relative;

  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 52px;
  margin-bottom: 16px;
  padding: 10px 16px;

  background: #ffffff;
  border-radius: 6px;

  box-sizing: border-box;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    box-shadow: 0 2px 4px rgba(55, 71, 79, 0.16),
    0 4px 8px rgba(55, 71, 79, 0.08);
  }

  &__item {
    display: flex;
    align-items: center;
    margin-right: 16px;

    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
    letter-spacing: 0.005em;
    color: #111111;

    @media (max-width: 1199px) {
      margin-right: 24px;
    }

    &--system {
      width: 183px;

      @media (max-width: 1199px) {
        width: 15%;
      }
    }

    &--complex-name {
      width: 513px;

      overflow: hidden;
      text-overflow: ellipsis;
      display: -moz-box;
      -moz-box-orient: vertical;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      line-clamp: 2;
      box-orient: vertical;

      @media (max-width: 1199px) {
        width: 27%
      }
    }

    &--date {
      width: 159px;

      @media (max-width: 1199px) {
        width: 25%
      }
    }

    &--specialist-name {
      width: 159px;

      @media (max-width: 1199px) {
        width: 17%;
      }
    }
  }

  &__button {
    position: absolute;
    top: 50%;
    right: 19px;
    z-index: 1;

    color: #8E8E93;

    transition: all 0.3s ease;
    transform: translateY(-50%);

    &:hover {
      opacity: 0.5;
    }

    @media (max-width: 1199px) {
      right: 17px;
    }
  }
}

.item {
  &__content {
    margin-left: 9px;
  }
}
</style>
